import { render, staticRenderFns } from "./text-length.vue?vue&type=template&id=981e43ba&scoped=true"
import script from "./text-length.vue?vue&type=script&lang=js"
export * from "./text-length.vue?vue&type=script&lang=js"
import style0 from "./text-length.vue?vue&type=style&index=0&id=981e43ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981e43ba",
  null
  
)

export default component.exports